import { ChakraFlex, CircularProgress } from '@equip.health/ui';

const OverviewLoading = ({
  height = 72,
  id = 'overview-loading',
  marginTop = '10px',
  size = '30px',
}: {
  height?: number;
  id?: string;
  marginTop?: string;
  size?: string;
}) => (
  <ChakraFlex
    alignItems="center"
    height={`${height}px`}
    justifyContent="center"
    marginTop={marginTop}
    width="100%"
  >
    <CircularProgress
      data-testid={id}
      id={id}
      isIndeterminate
      padding="8px"
      size={size}
    />
  </ChakraFlex>
);

export default OverviewLoading;
